import { useState, useEffect } from "react";
import { images } from "../constants/images";
import "../assets/stylesheets/bootstrap.min.css";
import "../assets/stylesheets/style.css";
import "../assets/stylesheets/responsive.css";
import AboutStyles from "./styles/About";

export default function AboutUs() {
  useEffect(() => {
    document.title =
      "About Us - Custom Business Software Development | Plural Code";
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="about-page">
      {/* HERO SECTION (Same as home page) */}
      <section
        style={{
          minHeight: "85vh",
          display: "flex",
          alignItems: "center",
          position: "relative",
          overflow: "hidden",
          background: "linear-gradient(135deg, #0a2458 0%, #1a3b8a 100%)",
        }}
      >
        {/* Background Elements */}
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: `
            radial-gradient(circle at 20% 80%, rgba(255, 215, 0, 0.15) 0%, transparent 50%),
            radial-gradient(circle at 80% 20%, rgba(255, 255, 255, 0.05) 0%, transparent 50%),
            radial-gradient(circle at 40% 40%, rgba(10, 36, 88, 0.2) 0%, transparent 50%)
          `,
          }}
        />

        <div className="container" style={{ paddingTop: "80px" }}>
          <div className="row align-items-center min-vh-90">
            <div className="col-lg-7 col-md-12 mb-5 mb-lg-0">
              <div
                className="text-white position-relative"
                style={{ zIndex: 2 }}
              >
                {/* Badge */}
                <div
                  className="d-inline-flex align-items-center gap-2 px-3 py-2 rounded-pill mb-4"
                  style={{
                    background: "rgba(255, 255, 255, 0.1)",
                    backdropFilter: "blur(10px)",
                    border: "1px solid rgba(255, 255, 255, 0.2)",
                  }}
                >
                  <span style={{ fontSize: "20px" }}>🚀</span>
                  <span
                    className="fw-bold"
                    style={{ fontSize: "14px", color: "#FFD700" }}
                  >
                    SINCE 2015
                  </span>
                </div>

                {/* Main Heading */}
                <h1
                  className="display-3 fw-bold mb-4"
                  style={{
                    lineHeight: "1.1",
                    background:
                      "linear-gradient(to right, #FFFFFF 0%, #E6F0FF 100%)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    backgroundClip: "text",
                    textShadow: "0 2px 10px rgba(0,0,0,0.1)",
                  }}
                >
                  We Build Software That{" "}
                  <span
                    className="d-inline-block"
                    style={{
                      background:
                        "linear-gradient(90deg, #FFD700 0%, #FFEC8B 100%)",
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                      backgroundClip: "text",
                      position: "relative",
                      padding: "0 5px",
                    }}
                  >
                    Powers Businesses
                  </span>
                </h1>

                {/* Subtitle */}
                <p
                  className="fs-5 mb-5"
                  style={{
                    color: "#E6F0FF",
                    lineHeight: "1.6",
                    maxWidth: "90%",
                    fontWeight: "300",
                  }}
                >
                  Not just features. We're your strategic tech partner that
                  builds tools solving real business problems with measurable
                  outcomes.
                </p>

                {/* CTA Buttons */}
                <div className="d-flex flex-wrap gap-3 mb-5">
                  <button
                    onClick={() =>
                      window.open(
                        "https://topmate.io/pluralcode/1677658",
                        "_blank",
                      )
                    }
                    className="btn btn-lg px-5 py-3 d-flex align-items-center gap-2"
                    style={{
                      background:
                        "linear-gradient(135deg, #FFD700 0%, #FFC107 100%)",
                      border: "none",
                      color: "#0a2458",
                      fontWeight: "700",
                      borderRadius: "12px",
                      transition: "all 0.3s ease",
                      boxShadow: "0 10px 30px rgba(255, 215, 0, 0.3)",
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.transform = "translateY(-3px)";
                      e.target.style.boxShadow =
                        "0 15px 40px rgba(255, 215, 0, 0.4)";
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.transform = "translateY(0)";
                      e.target.style.boxShadow =
                        "0 10px 30px rgba(255, 215, 0, 0.3)";
                    }}
                  >
                    <span>💬</span>
                    <span>Schedule Free Consultation</span>
                  </button>

                  {/* <button
                    onClick={() => window.open("/portfolio", "_blank")}
                    className="btn btn-lg px-5 py-3 d-flex align-items-center gap-2"
                    style={{
                      background: "transparent",
                      border: "2px solid #FFD700",
                      color: "#FFD700",
                      fontWeight: "600",
                      borderRadius: "12px",
                      transition: "all 0.3s ease",
                      backdropFilter: "blur(10px)",
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.background = "rgba(255, 215, 0, 0.1)";
                      e.target.style.transform = "translateY(-2px)";
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.background = "transparent";
                      e.target.style.transform = "translateY(0)";
                    }}
                  >
                    <span>📊</span>
                    <span>View Our Work</span>
                  </button> */}
                </div>

                {/* Trust Indicators */}
                <div className="d-flex flex-wrap align-items-center gap-4">
                  <div className="d-flex flex-column">
                    <div className="d-flex align-items-center gap-2 mb-1">
                      <span style={{ color: "#FFD700", fontSize: "20px" }}>
                        🌏
                      </span>
                      <span style={{ color: "#FFFFFF", fontWeight: "600" }}>
                        20+ Countries
                      </span>
                    </div>
                    <p
                      className="mb-0"
                      style={{ color: "#E6F0FF", fontSize: "14px" }}
                    >
                      Serving businesses across 4 continents since 2015
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Hero Image */}
            <div className="col-lg-5 col-md-12">
              <div className="position-relative">
                <div
                  style={{
                    position: "relative",
                    padding: "20px",
                  }}
                >
                  <div
                    style={{
                      position: "absolute",
                      top: "0",
                      right: "0",
                      bottom: "0",
                      left: "0",
                      background:
                        "linear-gradient(135deg, rgba(255,215,0,0.15) 0%, rgba(255,215,0,0) 50%)",
                      borderRadius: "25px",
                      transform: "rotate(5deg)",
                      zIndex: 0,
                    }}
                  />

                  <div
                    style={{
                      position: "relative",
                      borderRadius: "20px",
                      overflow: "hidden",
                      boxShadow: "0 25px 50px rgba(0,0,0,0.4)",
                      transform:
                        "perspective(1000px) rotateY(-5deg) rotateX(2deg)",
                      transition: "transform 0.5s ease",
                      zIndex: 1,
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform =
                        "perspective(1000px) rotateY(0deg) rotateX(0deg)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform =
                        "perspective(1000px) rotateY(-5deg) rotateX(2deg)";
                    }}
                  >
                    <img
                      src={images?.aboutUsBanner}
                      className="img-fluid w-100"
                      alt="About Plural Code Team"
                      style={{
                        display: "block",
                        height: "auto",
                        objectFit: "contain",
                        minHeight: "400px",
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Scroll Indicator */}
        <div
          style={{
            position: "absolute",
            bottom: "40px",
            left: "50%",
            transform: "translateX(-50%)",
            animation: "bounce 2s infinite",
          }}
        >
          <button
            onClick={() => {
              document
                .getElementById("what-makes-us-different")
                ?.scrollIntoView({ behavior: "smooth" });
            }}
            style={{
              background: "transparent",
              border: "none",
              color: "#FFD700",
              fontSize: "24px",
              cursor: "pointer",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <div style={{ transform: "rotate(90deg)", fontSize: "20px" }}></div>
            <div style={{ fontSize: "12px", letterSpacing: "2px" }}>SCROLL</div>
          </button>
        </div>
      </section>

      {/* WHAT MAKES US DIFFERENT */}
      <section
        id="what-makes-us-different"
        className="different-section"
        style={{
          padding: "100px 0",
          background: "linear-gradient(180deg, #FFFFFF 0%, #F8FAFF 100%)",
        }}
      >
        <div className="container">
          <div className="section-header text-center mb-5">
            <span
              className="px-3 py-1 rounded-pill d-inline-block mb-3"
              style={{
                background: "rgba(10, 36, 88, 0.1)",
                color: "#0a2458",
                fontWeight: "600",
                fontSize: "14px",
              }}
            >
              OUR DIFFERENCE
            </span>
            <h2
              className="head-font mb-4"
              style={{
                fontSize: "clamp(2rem, 4vw, 2.75rem)",
                color: "#0a2458",
              }}
            >
              What Makes Us Different?
            </h2>
            <p
              className="head-font2 fs-18 mx-auto"
              style={{
                maxWidth: "800px",
                color: "#0A2458",
                lineHeight: "1.6",
              }}
            >
              We get deeper. Instead of pushing ready-made tools, we work with
              you to understand your business inside-out and build valuable
              solutions. Whether it's a complex internal tool, AI-integrated
              ERP, or mobile-first product we care about clarity, scalability,
              and long-term value.
            </p>
          </div>

          <div className="row g-4">
            {[
              {
                icon: "🎯",
                title: "Extreme Customization",
                description:
                  "We don't force your business into pre-built templates. We build software around YOUR exact workflows and processes.",
              },
              {
                icon: "💬",
                title: "Transparent Communication",
                description:
                  "No jargon. No surprises. Weekly updates, clear timelines, honest conversations about what's possible.",
              },
              {
                icon: "💼",
                title: "Business-First Thinking",
                description:
                  "We care about your ROI, not just shipping code. Every feature is evaluated through the lens of business value.",
              },
              {
                icon: "⚡",
                title: "Agile & Adaptive",
                description:
                  "Requirements change. We embrace it. Our agile process keeps you in control while we handle the complexity.",
              },
              {
                icon: "🔑",
                title: "You Own Everything",
                description:
                  "Complete ownership of all code, designs, and IP. No vendor lock-in. No hidden dependencies.",
              },
              {
                icon: "🌏",
                title: "International Experience",
                description:
                  "We've built software for businesses across US, Australia, New Zealand, Singapore, Canada, and beyond.",
              },
            ].map((item, index) => (
              <div key={index} className="col-lg-4 col-md-6">
                <div
                  className="h-100 p-4 rounded-4"
                  style={{
                    background: "white",
                    border: "1px solid rgba(10, 36, 88, 0.1)",
                    boxShadow: "0 4px 6px rgba(10, 36, 88, 0.05)",
                    transition: "all 0.3s ease",
                    position: "relative",
                    overflow: "hidden",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-5px)";
                    e.currentTarget.style.boxShadow =
                      "0 12px 24px rgba(10, 36, 88, 0.1)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow =
                      "0 4px 6px rgba(10, 36, 88, 0.05)";
                  }}
                >
                  <div
                    style={{
                      position: "absolute",
                      top: "0",
                      left: "0",
                      right: "0",
                      height: "4px",
                      background:
                        "linear-gradient(90deg, #0a2458 0%, #1a3b8a 50%, #FFD700 100%)",
                    }}
                  />
                  <div
                    className="mb-4 rounded-3 d-inline-flex align-items-center justify-content-center"
                    style={{
                      fontSize: "40px",
                      width: "70px",
                      height: "70px",
                      background: "rgba(10, 36, 88, 0.05)",
                    }}
                  >
                    {item.icon}
                  </div>
                  <h3
                    className="head-font fs-20 mb-3"
                    style={{ color: "#0a2458" }}
                  >
                    {item.title}
                  </h3>
                  {/* <p
                    className="head-font2 fs-16 mb-0"
                    style={{ color: "#0A2458" }}
                  >
                    {item.description}
                  </p> */}

                  <p
                    className="head-font2 fs-17 mb-0"
                    style={{ color: "#0A2458" }}
                  >
                    {item.title === "You Own Everything" ? (
                      <>
                        Complete ownership of all code, designs
                        <br /> and IP. No vendor lock-in. No hidden
                        dependencies.
                      </>
                    ) : (
                      item.description
                    )}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* OUR TECH STACK */}
      <section
        className="tech-stack-section"
        style={{ padding: "100px 0", background: "#FFFFFF" }}
      >
        <div className="container">
          <div className="section-header text-center mb-5">
            <span
              className="px-3 py-1 rounded-pill d-inline-block mb-3"
              style={{
                background: "rgba(255, 215, 0, 0.15)",
                color: "#0a2458",
                fontWeight: "600",
                fontSize: "14px",
              }}
            >
              TECHNOLOGY
            </span>
            <h2
              className="head-font mb-4"
              style={{
                fontSize: "clamp(2rem, 4vw, 2.75rem)",
                color: "#0a2458",
              }}
            >
              Modern Tech Stack
            </h2>
            <p
              className="head-font2 fs-18 mx-auto"
              style={{
                maxWidth: "800px",
                color: "#0A2458",
                lineHeight: "1.6",
              }}
            >
              We use industry-leading technologies tailored to your specific
              needs always choosing the right tool for the job.
            </p>
          </div>

          <div className="tech-grid">
            {[
              {
                category: "Backend",
                tech: [
                  "Ruby on Rails",
                  "Python/Django",
                  "Node.js",
                  "PostgreSQL",
                ],
              },
              {
                category: "Frontend",
                tech: ["React.js", "TypeScript", "Next.js", "Tailwind CSS"],
              },
              {
                category: "Mobile",
                tech: [
                  "React Native",
                  "Flutter",
                  "iOS Swift",
                  "Android Kotlin",
                ],
              },
              {
                category: "Cloud & DevOps",
                tech: ["AWS", "Docker", "Kubernetes", "CI/CD"],
              },
              {
                category: "AI/ML",
                tech: ["TensorFlow", "OpenAI", "Computer Vision", "NLP"],
              },
              {
                category: "Database",
                tech: ["MongoDB", "Redis", "ElasticSearch", "MySQL"],
              },
            ].map((stack, index) => (
              <div key={index} className="tech-card">
                <div className="tech-card-header">
                  <h3
                    className="head-font fs-18 mb-0"
                    style={{ color: "#0a2458" }}
                  >
                    {stack.category}
                  </h3>
                </div>
                <div className="tech-card-body">
                  {stack.tech.map((tech, idx) => (
                    <div key={idx} className="tech-item">
                      <div className="tech-dot"></div>
                      <span
                        className="head-font2 fs-17"
                        style={{ color: "#0A2458" }}
                      >
                        {tech}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* HOW WE WORK */}
      <section
        className="how-we-work-section"
        style={{
          padding: "100px 0",
          background: "linear-gradient(180deg, #F8FAFF 0%, #FFFFFF 100%)",
        }}
      >
        <div className="container">
          <div className="section-header text-center mb-5">
            <span
              className="px-3 py-1 rounded-pill d-inline-block mb-3"
              style={{
                background: "rgba(10, 36, 88, 0.1)",
                color: "#0a2458",
                fontWeight: "600",
                fontSize: "14px",
              }}
            >
              OUR PROCESS
            </span>
            <h2
              className="head-font mb-4"
              style={{
                fontSize: "clamp(2rem, 4vw, 2.75rem)",
                color: "#0a2458",
              }}
            >
              How We Work
            </h2>
            <p
              className="head-font2 fs-18 mx-auto"
              style={{
                maxWidth: "800px",
                color: "#0A2458",
                lineHeight: "1.6",
              }}
            >
              A proven methodology that ensures your software perfectly matches
              your business needs
            </p>
          </div>

          <div className="process-steps">
            {[
              {
                number: 1,
                title: "Discovery First",
                description:
                  "We invest time understanding your business, pain points, and growth goals before writing any code.",
                image: images?.step1,
              },
              {
                number: 2,
                title: "Agile Development",
                description:
                  "Weekly sprints, transparent progress updates, and continuous collaboration ensure we're always aligned.",
                image: images?.step3,
              },
              {
                number: 3,
                title: "Complete Ownership",
                description:
                  "You own 100% of the code, data, and IP. No vendor lock-in, just complete control.",
                image: images?.step2,
              },
            ].map((step, index) => (
              <div key={index} className="process-step">
                <div className="step-header">
                  <div className="step-number">{step.number}</div>
                  <h3 className="head-font fs-24" style={{ color: "#0a2458" }}>
                    {step.title}
                  </h3>
                </div>
                <div className="step-content">
                  <div className="step-image">
                    <img
                      src={step.image}
                      alt={step.title}
                      className="img-fluid"
                      style={{
                        borderRadius: "12px",
                        boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
                      }}
                    />
                  </div>
                  <div className="step-description">
                    <p
                      className="head-font2"
                      style={{
                        color: "#0A2458",
                        lineHeight: "1.6",
                        fontSize: 21,
                      }}
                    >
                      {step.description}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* WHAT WE BELIEVE IN */}
      <section
        className="beliefs-section"
        style={{ padding: "100px 0", background: "#FFFFFF" }}
      >
        <div className="container">
          <div className="section-header text-center mb-5">
            <span
              className="px-3 py-1 rounded-pill d-inline-block mb-3"
              style={{
                background: "rgba(255, 215, 0, 0.15)",
                color: "#0a2458",
                fontWeight: "600",
                fontSize: "14px",
              }}
            >
              OUR BELIEFS
            </span>
            <h2
              className="head-font mb-4"
              style={{
                fontSize: "clamp(2rem, 4vw, 2.75rem)",
                color: "#0a2458",
              }}
            >
              What We Believe In
            </h2>
            <p
              className="head-font2 fs-18 mx-auto"
              style={{
                maxWidth: "800px",
                color: "#0A2458",
                lineHeight: "1.6",
              }}
            >
              Our core principles guide every project we undertake
            </p>
          </div>

          <div className="beliefs-grid">
            {[
              {
                icon: "⚙️",
                title: "Build for Business Value",
                description:
                  "Features are important, but ROI matters more. We build tools that move needles, not just check boxes.",
              },
              {
                icon: "👁️",
                title: "Think Long-Term",
                description:
                  "Shortcuts feel good now, but they cost more later. We plan for scalability and maintainability.",
              },
              {
                icon: "🍪",
                title: "Beyond Cookie-Cutter",

                description:
                  "Your business is unique. Your software shouldn't be generic. Tailored beats templated every time.",
              },
              {
                icon: "💙",
                title: "Care Like It's Ours",
                description:
                  "We stick around, guide, support, and care. Your long-term growth is our responsibility.",
              },
            ].map((belief, index) => (
              <div key={index} className="belief-card">
                <div className="belief-icon">{belief.icon}</div>
                <h3
                  className="head-font fs-18 mb-3"
                  style={{ color: "#0a2458" }}
                >
                  {belief.title}
                </h3>
                <p
                  className="head-font2 fs-16 mb-0"
                  style={{ color: "#0A2458", lineHeight: "1.6" }}
                >
                  {belief.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* WHO WE SERVE */}
      <section
        className="industries-section"
        style={{
          padding: "100px 0",
          background: "linear-gradient(180deg, #F8FAFF 0%, #FFFFFF 100%)",
        }}
      >
        <div className="container">
          <div className="section-header text-center mb-5">
            <span
              className="px-3 py-1 rounded-pill d-inline-block mb-3"
              style={{
                background: "rgba(10, 36, 88, 0.1)",
                color: "#0a2458",
                fontWeight: "600",
                fontSize: "14px",
              }}
            >
              INDUSTRIES
            </span>
            <h2
              className="head-font mb-4"
              style={{
                fontSize: "clamp(2rem, 4vw, 2.75rem)",
                color: "#0a2458",
              }}
            >
              Who We Serve
            </h2>
            <p
              className="head-font2 fs-18 mx-auto"
              style={{
                maxWidth: "800px",
                color: "#0A2458",
                lineHeight: "1.6",
              }}
            >
              We work with mid-to-large businesses across diverse industries who
              need software that solves complex operational challenges.
            </p>
          </div>

          <div className="industries-grid">
            {[
              {
                icon: "🏭",
                title: "Manufacturing",
                description:
                  "Process management, inventory tracking, production optimization",
              },
              {
                icon: "🏥",
                title: "Healthcare",
                description:
                  "Patient management, telemedicine platforms, clinic operations",
              },
              {
                icon: "🚚",
                title: "Logistics",

                description: (
                  <>
                    Fleet management, route optimization,
                    <br /> delivery tracking,
                  </>
                ),
              },
              {
                icon: "🏪",
                title: "Retail & E-commerce",

                description: (
                  <>Custom POS, inventory systems, omnichannel platforms</>
                ),
              },
              {
                icon: "💼",
                title: "Professional Services",

                description: (
                  <>Client portals, project management, billing systems</>
                ),
              },
              {
                icon: "🏦",
                title: "Finance & Insurance",
                description:
                  "Custom CRM, claims processing, risk management tools",
              },
            ].map((industry, index) => (
              <div key={index} className="industry-card">
                <div className="industry-icon">{industry.icon}</div>
                <h3
                  className="head-font fs-18 mb-3"
                  style={{ color: "#0a2458" }}
                >
                  {industry.title}
                </h3>
                <p
                  className="head-font2 fs-16 mb-0"
                  style={{ color: "#0A2458", lineHeight: "1.6" }}
                >
                  {industry.description}
                </p>
              </div>
            ))}
          </div>

          <div className="text-center mt-5">
            <div
              className="p-4 rounded-4 d-inline-block"
              style={{
                background:
                  "linear-gradient(135deg, rgb(10, 36, 88) 0%, rgb(26, 59, 138) 100%)",
              }}
            >
              <p className="head-font2 fs-16 mb-0" style={{ color: "#FFD700" }}>
                <strong>Your industry not listed?</strong> We adapt to any
                business model with complex workflows.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* INTERNATIONAL CLIENTS */}
      <section
        className="international-section"
        style={{ padding: "100px 0", background: "#FFFFFF" }}
      >
        <div className="container">
          <div className="section-header text-center mb-5">
            <span
              className="px-3 py-1 rounded-pill d-inline-block mb-3"
              style={{
                background: "rgba(10, 36, 88, 0.1)",
                color: "#0a2458",
                fontWeight: "600",
                fontSize: "14px",
              }}
            >
              GLOBAL REACH
            </span>
            <h2
              className="head-font mb-4"
              style={{
                fontSize: "clamp(2rem, 4vw, 2.75rem)",
                color: "#0a2458",
              }}
            >
              Built for International Teams
            </h2>
            <p
              className="head-font2 fs-18 mx-auto"
              style={{
                maxWidth: "800px",
                color: "#0A2458",
                lineHeight: "1.6",
              }}
            >
              We've delivered solutions across 4 continents, understanding the
              nuances of global collaboration.
            </p>
          </div>

          <div className="row g-4">
            <div className="col-lg-4 col-md-6">
              <div
                className="p-4 h-100 rounded-4"
                style={{
                  background: "rgba(10, 36, 88, 0.02)",
                  border: "1px solid rgba(10, 36, 88, 0.1)",
                }}
              >
                <div className="d-flex align-items-center gap-3 mb-3">
                  <div style={{ fontSize: "32px" }}>🌏</div>
                  <h3
                    className="head-font fs-18 mb-0"
                    style={{ color: "#0a2458" }}
                  >
                    Time Zone Flexibility
                  </h3>
                </div>
                <p
                  className="head-font2 fs-16 mb-0"
                  style={{ color: "#0A2458" }}
                >
                  We schedule meetings that work for you whether you're in
                  Sydney, Singapore, or Toronto.
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div
                className="p-4 h-100 rounded-4"
                style={{
                  background: "rgba(10, 36, 88, 0.02)",
                  border: "1px solid rgba(10, 36, 88, 0.1)",
                }}
              >
                <div className="d-flex align-items-center gap-3 mb-3">
                  <div style={{ fontSize: "32px" }}>📞</div>
                  <h3
                    className="head-font fs-18 mb-0"
                    style={{ color: "#0a2458" }}
                  >
                    Clear Communication
                  </h3>
                </div>
                <p
                  className="head-font2 fs-16 mb-0"
                  style={{ color: "#0A2458" }}
                >
                  No language barriers. No cultural confusion. Clear,
                  professional English communication.
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div
                className="p-4 h-100 rounded-4"
                style={{
                  background: "rgba(10, 36, 88, 0.02)",
                  border: "1px solid rgba(10, 36, 88, 0.1)",
                }}
              >
                <div className="d-flex align-items-center gap-3 mb-3">
                  <div style={{ fontSize: "32px" }}>🤝</div>
                  <h3
                    className="head-font fs-18 mb-0"
                    style={{ color: "#0a2458" }}
                  >
                    Business Understanding
                  </h3>
                </div>
                <p
                  className="head-font2 fs-16 mb-0"
                  style={{ color: "#0A2458" }}
                >
                  We follow global business standards, ensuring compliance and
                  professional excellence.
                </p>
              </div>
            </div>
          </div>

          <div className="text-center mt-5">
            <div className="d-flex justify-content-center gap-4 flex-wrap">
              {[
                "Australia",
                "New Zealand",
                "Singapore",
                "Canada",
                "USA",
                "India",
              ].map((country, idx) => (
                <div key={idx} className="country-badge">
                  {country}
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* FOUNDER SECTION */}
      {/* <section
        className="founder-section"
        style={{
          padding: "100px 0",
          background: "linear-gradient(135deg, #0a2458 0%, #1a3b8a 100%)",
          color: "white",
        }}
      >
        <div className="container">
          <div className="section-header text-center mb-5">
            <span
              className="px-3 py-1 rounded-pill d-inline-block mb-3"
              style={{
                background: "rgba(255, 255, 255, 0.15)",
                color: "white",
                fontWeight: "600",
                fontSize: "14px",
                backdropFilter: "blur(10px)",
              }}
            >
              LEADERSHIP
            </span>
            <h2
              className="head-font mb-4"
              style={{
                fontSize: "clamp(2rem, 4vw, 2.75rem)",
              }}
            >
              About the Founder
            </h2>
          </div>

          <div className="row align-items-center">
            <div className="col-lg-4 mb-4 mb-lg-0">
              <div className="founder-image-container">
                <img
                  src={images?.nishant}
                  alt="Nishant Goyal - Founder"
                  className="img-fluid  founder-image"
                  style={{
                    borderRadius: "20px",
                    boxShadow: "0 20px 40px rgba(0,0,0,0.3)",
                  }}
                />
              </div>
            </div>
            <div className="col-lg-8 ps-lg-5">
              <h3 className="head-font fs-32 mb-3">Nishant Goyal</h3>
              <p className="head-font2 fs-20 mb-4" style={{ color: "#FFD700" }}>
                Founder & CEO
              </p>
              <div className="founder-content">
                <p
                  className="head-font2 fs-17 mb-3"
                  style={{ color: "rgba(255, 255, 255, 0.9)" }}
                >
                  {" "}
                  Hi, I’m Nishant Goyal – Founder & CEO of Plural Code
                  Technologies.
                </p>
                <p
                  className="head-font2 fs-17 mb-3"
                  style={{ color: "rgba(255, 255, 255, 0.9)" }}
                >
                  At Plural Code, we don't just build software we architect
                  digital solutions that scale businesses. What started as a
                  two-person team with a shared vision has grown into a globally
                  recognised IT services company, serving over 200 clients
                  across 10+ countries.
                </p>

                <p
                  className="head-font2 fs-17 mb-3"
                  style={{ color: "rgba(255, 255, 255, 0.9)" }}
                >
                  With 14+ years in tech, our core strength lies in leading
                  complex digital transformations, blending deep technical
                  expertise with business insight. Under my leadership, Plural
                  Code has consistently been ranked among top IT solution
                  providers for three years in a row.
                </p>

                <p
                  className="head-font2 fs-17 mb-3"
                  style={{ color: "rgba(255, 255, 255, 0.9)" }}
                >
                  We're known for turning bold ideas into reliable, scalable
                  platforms from custom business software systems to
                  mobile-first apps, cloud-native web solutions, and more.
                </p>
                <p
                  className="head-font2 fs-17 mb-3"
                  style={{ color: "rgba(255, 255, 255, 0.9)" }}
                >
                  Tech is the tool. Vision, execution, and integrity are what we
                  truly deliver. Started coding at 14, building business
                  software professionally since 2015. I founded Plural Code
                  because I saw too many businesses struggling with software
                  that didn't fit their needs forced to adapt their workflows to
                  generic tools instead of having tools that adapt to them.
                </p>
                <p
                  className="head-font2 fs-17 mb-3"
                  style={{ color: "rgba(255, 255, 255, 0.9)" }}
                >
                  I believe software should be a competitive advantage, not a
                  compromise. Every project we take on, I'm personally involved
                  from discovery to deployment ensuring we build something that
                  truly moves the needle for your business.
                </p>
                <p
                  className="head-font2 fs-17 mb-0"
                  style={{ color: "rgba(255, 255, 255, 0.9)" }}
                >
                  When I'm not coding, I'm probably researching new
                  technologies, reading about business strategy, or planning the
                  next innovation for our clients.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section> */}

      {/* WHY CHOOSE US - SUMMARY */}
      <section
        className="why-choose-section"
        style={{ padding: "100px 0", background: "#FFFFFF" }}
      >
        <div className="container">
          <div className="section-header text-center mb-5">
            <span
              className="px-3 py-1 rounded-pill d-inline-block mb-3"
              style={{
                background: "rgba(255, 215, 0, 0.15)",
                color: "#0a2458",
                fontWeight: "600",
                fontSize: "14px",
              }}
            >
              WHY CHOOSE US
            </span>
            <h2
              className="head-font mb-4"
              style={{
                fontSize: "clamp(2rem, 4vw, 2.75rem)",
                color: "#0a2458",
              }}
            >
              Why Work With Plural Code?
            </h2>
          </div>

          <div className="reasons-grid">
            {[
              {
                title: "Strategic Partners",
                description:
                  "We're not just developers we're partners who care about your business outcomes.",
              },
              {
                title: "Proven Track Record",
                description:
                  "Since 2015, delivering complex custom software for businesses worldwide.",
              },
              {
                title: "Transparent Process",
                description:
                  "You always know what's happening, what's next, and why. No black boxes.",
              },
              {
                title: "Complete Ownership",
                description:
                  "Full code ownership. No licensing fees. Your software, your rules.",
              },
              {
                title: "ROI-Focused",
                description:
                  "Every feature is evaluated for business value. We build tools that pay for themselves.",
              },
              {
                title: "Long-Term Partnership",
                description:
                  "We don't disappear after launch. Ongoing support and strategic guidance.",
              },
            ].map((reason, index) => (
              <div key={index} className="reason-card">
                <div className="reason-check">✓</div>
                <div>
                  <h3
                    className="head-font fs-18 mb-2"
                    style={{ color: "#0a2458" }}
                  >
                    {reason.title}
                  </h3>
                  <p
                    className="head-font2 fs-16 mb-0"
                    style={{ color: "#0A2458" }}
                  >
                    {reason.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA SECTION */}
      <section
        className="cta-section"
        style={{
          padding: "100px 0",
          background: "linear-gradient(135deg, #0a2458 0%, #1a3b8a 100%)",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundImage: `radial-gradient(circle at 25% 25%, rgba(255, 215, 0, 0.1) 2px, transparent 2px)`,
            backgroundSize: "40px 40px",
          }}
        />

        <div className="container position-relative" style={{ zIndex: 1 }}>
          <div className="text-center mb-5">
            <span
              className="px-3 py-1 rounded-pill d-inline-block mb-3"
              style={{
                background: "rgba(255, 255, 255, 0.15)",
                color: "white",
                fontWeight: "600",
                fontSize: "14px",
                backdropFilter: "blur(10px)",
              }}
            >
              GET STARTED
            </span>
            <h2 className="head-font fs-44 mb-4" style={{ color: "white" }}>
              Ready to Build Software That Actually Fits?
            </h2>
            <p
              className="head-font2 fs-20 mb-5 mx-auto"
              style={{
                color: "rgba(255, 255, 255, 0.9)",
                maxWidth: "700px",
              }}
            >
              Let's have an honest conversation about your challenges, your
              goals, and whether custom software is the right solution.
            </p>
          </div>

          <div className="d-flex flex-wrap justify-content-center gap-4 mb-5">
            <button
              onClick={() =>
                window.open("https://topmate.io/pluralcode/1677658", "_blank")
              }
              className="btn btn-lg px-5 py-3 d-flex align-items-center gap-2"
              style={{
                background: "linear-gradient(135deg, #FFD700 0%, #FFC107 100%)",
                border: "none",
                color: "#0a2458",
                fontWeight: "700",
                borderRadius: "12px",
                transition: "all 0.3s ease",
                boxShadow: "0 10px 30px rgba(255, 215, 0, 0.3)",
              }}
              onMouseEnter={(e) => {
                e.target.style.transform = "translateY(-3px)";
                e.target.style.boxShadow = "0 15px 40px rgba(255, 215, 0, 0.4)";
              }}
              onMouseLeave={(e) => {
                e.target.style.transform = "translateY(0)";
                e.target.style.boxShadow = "0 10px 30px rgba(255, 215, 0, 0.3)";
              }}
            >
              <span>💬</span>
              <span>Schedule Free Consultation</span>
            </button>

            <button
              onClick={() => window.open("/services", "_blank")}
              className="btn btn-lg px-5 py-3 d-flex align-items-center gap-2"
              style={{
                background: "transparent",
                border: "2px solid #FFD700",
                color: "#FFD700",
                fontWeight: "600",
                borderRadius: "12px",
                transition: "all 0.3s ease",
                backdropFilter: "blur(10px)",
              }}
              onMouseEnter={(e) => {
                e.target.style.background = "rgba(255, 215, 0, 0.1)";
                e.target.style.transform = "translateY(-2px)";
              }}
              onMouseLeave={(e) => {
                e.target.style.background = "transparent";
                e.target.style.transform = "translateY(0)";
              }}
            >
              <span>⚙️</span>
              <span>Explore Our Services</span>
            </button>
          </div>

          <div className="text-center">
            <div className="row justify-content-center">
              <div className="col-lg-8">
                <div
                  className="p-4 rounded-4"
                  style={{
                    background: "rgba(255, 255, 255, 0.1)",
                    border: "1px solid rgba(255, 255, 255, 0.2)",
                    backdropFilter: "blur(10px)",
                  }}
                >
                  <div className="row g-4">
                    <div className="col-md-6">
                      <div className="text-center">
                        <div
                          className="head-font2 fs-17 mb-1"
                          style={{ color: "rgba(255, 255, 255, 0.8)" }}
                        >
                          Email
                        </div>
                        <div
                          className="head-font2 fs-17 fw-bold"
                          style={{ color: "white" }}
                        >
                          info@pluralcode.com
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="text-center">
                        <div
                          className="head-font2 fs-17 mb-1"
                          style={{ color: "rgba(255, 255, 255, 0.8)" }}
                        >
                          Phone
                        </div>
                        <div
                          className="head-font2 fs-17 fw-bold"
                          style={{ color: "white" }}
                        >
                          +91 99589 20231
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <p
                  className="head-font2 fs-17 mt-4 mb-0"
                  style={{ color: "rgba(255, 255, 255, 0.9)" }}
                >
                  Serving businesses of all sizes and industries around the
                  world.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <AboutStyles />
    </div>
  );
}
